import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "./confirmation.service";

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  host: { ngSkipHydration: 'true' }
})
export class ConfirmationModalComponent implements OnInit {
  ConfirmationService: ConfirmationService;

  constructor(private confirmationService: ConfirmationService) {
    this.ConfirmationService = confirmationService;
  }

  ngOnInit(): void {
  }
}
